// extracted by mini-css-extract-plugin
export default {"default":"BookmarkButton-module__default__TTL17","active":"BookmarkButton-module__active__k6OYz BookmarkButton-module__default__TTL17"};